import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';
import { Employee } from '@synergy/models';

import { DeleteEmployeeRequest } from './delete-employee-request';
import { UpdateEmployeeRequest } from './update-employee-request';

export class SupplierEmployeeApi {
    constructor(protected baseUrl: string) {}

    public getEmployees(supplierId: number): Promise<ApiResult<Employee[]>> {
        return safeRequest(
            () =>
                request.get<Employee[]>(`${this.baseUrl}/suppliers/${supplierId}/employees`, {
                    params: new URLSearchParams({ limit: '10000' }),
                }),
            response => response.data
        );
    }

    public AddEmployee(customerId: number, contactId: number, positionId?: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/suppliers/${customerId}/employees/${contactId}`, { positionId }),
            () => null
        );
    }

    public updateEmployee(
        customerId: number,
        contactId: number,
        updateRequest: UpdateEmployeeRequest
    ): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.patch(`${this.baseUrl}/suppliers/${customerId}/employees/${contactId}`, updateRequest),
            () => null
        );
    }

    public deleteEmployee(
        customerId: number,
        contactId: number,
        deleteRequest: DeleteEmployeeRequest
    ): Promise<ApiResult<null>> {
        return safeRequest(
            () =>
                request.delete(`${this.baseUrl}/suppliers/${customerId}/employees/${contactId}`, {
                    data: deleteRequest,
                }),
            () => null
        );
    }

    public searchEmployees(supplierId: number, search?: string): Promise<ApiResult<Employee[]>> {
        const params = new URLSearchParams();
        if (search) {
            params.set('search', search);
        }
        return safeRequest(
            () =>
                request.get<PaginatedResponse<Employee>>(`${this.baseUrl}/suppliers/${supplierId}/employees/search`, {
                    params,
                }),
            response => response.data.items
        );
    }
}
